import React from "react";
import { MessageBanner } from "@folio/stripes/components";
import { useIntl } from "react-intl";
/**
 * Persistent warning on a person detail while the last send of the person's
 * authority record to NK authorities (Aleph) failed. It disappears once a
 * later send succeeds (the backend clears the stored error).
 */
export var AuthoritySendErrorBanner = function (_a) {
    var person = _a.person;
    var _b = useIntl(), formatMessage = _b.formatMessage, formatDate = _b.formatDate;
    if (!person.authoritySendError) {
        return null;
    }
    var date = person.authoritySendErrorAt
        ? formatDate(person.authoritySendErrorAt, {
            dateStyle: "short",
            timeStyle: "medium",
        })
        : "";
    return (React.createElement(MessageBanner, { type: "warning" }, formatMessage({ id: "ui-br-agency.person.authoritySend.error.banner" }, { error: person.authoritySendError, date: date })));
};
